exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/global.css"), undefined);

// module
exports.push([module.id, ".group_e70 > *:not(:last-child) {\n\n    margin-right: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"unit": "" + require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/global.css").locals["unit"] + "",
	"group": "group_e70"
};